import "../../scss/TimelineTable.scss"
import { formatSalesValue } from "../../utils/formatUtils"
import ConvertTime from './ConvertTime'

const TimelineTable = ({ tableSumamry }) => {
    return (
        <div className="table-timeline-responsive tiny-scrollbar">
            <table className="table-timeline">
                <thead>
                    <tr className='position-sticky'>
                        <th className='no-wrap'>Date</th>
                        <th className='no-wrap'>Table No</th>
                        <th className='no-wrap'>PAX</th>
                        <th>Start Time</th>
                        <th>Bill Print Time</th>
                        <th>End Time</th>
                        <th>Duration</th>
                        <th>Type</th>
                        <th>Server</th>
                        <th>Bill No</th>
                        {/* <th>Guest Name</th> */}
                        <th>Total</th>
                        <th>Payment Mode</th>
                        <th>Rev. Per Guest</th>
                        <th className='timeline-item'>Items</th>
                    </tr>
                </thead>
                <tbody>
                    {tableSumamry.map((info, index) => (
                        <tr key={index}>
                            <td className='no-wrap'>{info.Date}</td>
                            <td>{info.Table_No}</td>
                            <td>{info.NoOfGuests}</td>
                            <td className='no-wrap'><ConvertTime time={info.Start_Time} /></td>
                            <td className='no-wrap'>{info.billPrintTime}</td>
                            <td className='no-wrap'><ConvertTime time={info.End_Time} /></td>
                            <td>{info.duration}</td>
                            <td className="whitespace-nowrap">{info.Type}</td>
                            <td>{info.server}</td>
                            <td className="whitespace-nowrap">{info.formatted_bill_no || info.bill_no}</td>
                            {/* <td>{info.GuestName}</td> */}
                            <td>{formatSalesValue(info.Total)}</td>
                            <td>{info.PaymentMode}</td>
                            <td>{info.revperguest}</td>
                            <td >
                                <div className='timeline-item-td'>
                                    {info.items}
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default TimelineTable